import closeSquareOutline from '@iconify/icons-eva/close-square-outline';
import minusSquareOutline from '@iconify/icons-eva/minus-square-outline';
import plusSquareOutline from '@iconify/icons-eva/plus-square-outline';
import { Icon } from '@iconify/react';
import { Theme } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import React from 'react';

// ----------------------------------------------------------------------

const ICON_SIZE = { width: 20, height: 20 };

export default function TreeView(theme: Theme, containerId: string) {
  return {
    MuiTreeView: {
      defaultProps: {
        container: document.getElementById(containerId),
        defaultCollapseIcon: <Icon icon={minusSquareOutline} {...ICON_SIZE} />,
        defaultExpandIcon: <Icon icon={plusSquareOutline} {...ICON_SIZE} />,
        defaultEndIcon: (
          <Box
            component={Icon}
            icon={closeSquareOutline}
            {...ICON_SIZE}
            sx={{ color: 'text.secondary' }}
          />
        ),
      },
    },
    MuiTreeItem: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        label: { ...theme.typography.body2 },
        iconContainer: { width: 'auto' },
      },
    },
  };
}
